module.exports = __webpack_public_path__ + "static/media/portrait11.288fe092.jpg";